import Axios from '@/plugins/axios';
import { onlineUrl } from '@/utils/config';

// 意向询盘,未设置筛选条件或非付费会员时，返回“匹配询盘”列表
export function getFavoriteRfqList(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/supplier/rfq/match/list`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}

// 查询询盘此处的筛选
export function getFavoriteDict() {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/supplier/rfq/init-dict`,
    method: 'GET',
    params: {}
  }
  return Axios(config);
}

// 更多推荐询盘
export function getRecommendMoreRfqList(params) {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/supplier/rfq/recommend`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}


// 消息待查看数量
export function getUnReadMessageNum(params) {
  const config = {
    url: `${ onlineUrl }/mk-leads/common/user/un-read-message-num`,
    method: 'GET',
    params: params || {}
  }
  return Axios(config);
}

// 获取  匹配询盘、邀请报价、授盘待接受、生产进度、待评价 的气泡数量
export function getOtherNum() {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/supplier/rfq/statistics-num`,
    method: 'GET',
    params: {}
  }
  return Axios(config);
}

// 获取  营销邮件一些气泡数量
export function getEmailStatusNum() {
  const config = {
    url: `${ onlineUrl }/seamark/supplier/edm-subject/statistic`,
    method: 'GET',
    params: {}
  }
  return Axios(config);
}

// 客户经理
export function salesInfo(params) {
  const config = {
    url: `${ onlineUrl }/mk-leads/leads/sales-info`,
    method: 'GET',
    params: params || {}
  }
  return Axios(config);
}

// 获取续约信息
export function getRenewalInfo(params) {
  const config = {
    url: `${ onlineUrl }/mk-leads/supplier/profile/comp-rc-sales-info`,
    method: 'GET',
    params: params || {}
  }
  return Axios(config);
}

// 会员信息
export function getMemberInfo(params) {
  const membershipApiBase = process.env.VUE_APP_MEMBERSHIP_API_BASE || `${onlineUrl}/mk-leads`;
  const config = {
    url: `${membershipApiBase}/supplier/profile/comp-senior-member-info`,
    baseURL: '',
    method: 'GET',
    params: params || {}
  }
  return Axios(config);
}

// 热门活动 
export function getListByType(params) {
  const config = {
    url: `${ onlineUrl }/biz-data/advertising/get-list-by-type`,
    method: 'POST',
    data: params
  }
  return Axios(config);
}
//插入曝光量
export function insertAdvertisingEffect(params) {
  const config = {
    url: `${ onlineUrl }/biz-data/advertising/insert-advertising-effect`,
    method: "POST",
    data: params
  };
  return Axios(config);
}

//插入点击量
export function insertAdvertisingClick(params) {
  const config = {
    url: `${ onlineUrl }/biz-data/advertising/insert-advertising-click`,
    method: "POST",
    data: params,
    async: false,
  };
  return Axios(config);
}
//更新点击量
export function updateAdvertisingClick(params) {
  const config = {
    url: `${ onlineUrl }/biz-data/advertising/update-advertising-click`,
    method: "POST",
    data: params
  };
  return Axios(config);
}

/**
 * 查询登录频次（询盘查看及报价数量指标）
 */
export function getLoginRatioAndInquiryView(params) {
  const config = {
    url: `${ onlineUrl }/leads/supplier/analysis/usage-frequency`,
    method: "POST",
    data: params
  };
  return Axios(config);
}
/**
 * 对接采购资源词云
 */
export function getDockBuyerWordCloud(params) {
  const config = {
    url: `${ onlineUrl }/leads/supplier/analysis/docking-buyer`,
    method: "POST",
    data: params
  };
  return Axios(config);
}
// 数据统计
export function getDataAssistant(params) {
  const config = {
    url: `${ onlineUrl }/mk-leads/dashboard/data-assistant`,
    // url: `http://n360.haizol.com:11151/mk-leads/dashboard/commons`,
    method: "POST",
    data: params
  };
  return Axios(config);
}
// 详细数据列表
export function getDataDetail(params) {
  const config = {
    url: `${ onlineUrl }/mk-leads/dashboard/visited-list`,
    // url: `http://n360.haizol.com:11151/mk-leads/dashboard/visited-list`,
    method: "POST",
    data: params
  };
  return Axios(config);
}
// 生态订单概况数量
export function zoologyNum() {
  const config = {
    url: `${ onlineUrl }/mk-rfq-api/partner/rfq/statistics-num`,
    // url: `/need/mk-rfq-api/partner/rfq/statistics-num`,
    method: 'GET',
  }
  return Axios(config);
}

// 产品状态统计
export function getProductManageState(params={}) {
  const config = {
    url: `${ onlineUrl }/mk-topping-api/supplier/product/product-state-account`,
    // url: `http://n360.haizol.com:11151/mk-leads/dashboard/visited-list`,
    method: "POST",
    data: params
  };
  return Axios(config);
};
// 获取更新公共
export const getNoteActiveByType = (params) => {
   const config = {
    url: `${ onlineUrl }/biz-data/sys-note/get-list-by-type?zlan=zh`,
    method: "POST",
    data: params
  };
  return Axios(config);
};

/**
 * 获取最新产品更新，id为空则无最新公告
 */
export function getVersion() {
   const config = {
    url: `${onlineUrl}/biz-data/sys-note/get-product-new-version`,
        method: "get",
  };
  return Axios(config);
}
/**
 * 阅读最新产品更新
 */
export function getReadVersion(data) {
    const config = {
    url: `${ onlineUrl }/biz-data/sys-note/read-product-new-version`,
    method: "POST",
    data
  };
  return Axios(config);
 
}
/**
 * 未读消息最多三条
 */
export function getUnReadMsgNumApi(data) {
    const config = {
    url: `${ onlineUrl }/mk-leads/supplier/message/query-unread-message`,
    method: "POST",
    data
  };
  return Axios(config);
 
}

/**
 * 查询供应商过期资质认证列表
 */
export function findQC() {
    const config = {
    url: `${ onlineUrl }/mk-leads/supplier/profile/comp-cert-expire-info`,
    method: "GET",
    
  };
  return Axios(config);
 
}
